namespace $.$$ {
	$mol_style_define($bog_blitz_blog_menu, {
		Logo: {
			width: '120px',
			height: '120px',
			align: {
				self: 'center',
			},
			margin: {
				top: '32px',
				bottom: '16px',
			},
		},
		Heading: {
			font: {
				size: '28px',
				weight: 700,
			},
			textAlign: 'center',
		},
		Subtitle: {
			font: {
				size: '16px',
			},
			textAlign: 'center',
			opacity: 0.6,
			margin: {
				bottom: '32px',
			},
		},
		Link: {
			font: {
				size: '18px',
			},
			padding: {
				top: '12px',
				bottom: '12px',
				left: '16px',
				right: '16px',
			},
			borderRadius: '8px',
		},
	})
}
